// Transcribed verbatim from the client's V2 document, punctuation included: curly quotes
// and apostrophes, `$350-$500`, `Carcinogenic Category 1B`, the US `child-labor` sitting a
// stop away from the UK `child labour`, and `Welcome to iPhone` alone in carrying no full
// stop. Don't tidy any of it.
//
// Two mechanical concessions, both so the card can render what the prose used to only say:
// the client's Location column is lifted out to `place` (it used to lead the body behind an
// em dash), and each body's trailing citation group to `citations`. Nothing else moves.
export default {
  label: {
    id: 'rm_journey_human_label',
    defaultMessage: 'Mine its Human Impact',
  },

  introLabel: {
    id: 'rm_journey_human_intro_label',
    defaultMessage: 'Intro',
  },
  introTitle: {
    id: 'rm_journey_human_intro_title',
    defaultMessage: 'Cobalt’s human toll',
  },
  introBody: {
    id: 'rm_journey_human_intro_body',
    defaultMessage: 'Cobalt is a key metal used in many smartphone batteries.',
  },
  introBodyTwo: {
    id: 'rm_journey_human_intro_body_two',
    defaultMessage:
      'From extraction to manufacture to sale, trace the impact of Cobalt on people across the planet.',
  },
  introCta: {
    id: 'rm_journey_human_intro_cta',
    defaultMessage: 'Next',
  },

  extractionLabel: {
    id: 'rm_journey_human_extraction_label',
    defaultMessage: 'Extraction',
  },
  extractionTitle: {
    id: 'rm_journey_human_extraction_title',
    defaultMessage: 'A child in the mine.',
  },
  extractionPlace: {
    id: 'rm_journey_human_extraction_place',
    defaultMessage: 'Mutanda & Kamoto, DRC',
  },
  extractionBody: {
    id: 'rm_journey_human_extraction_body',
    defaultMessage:
      'In a hand-dug tunnel, a child as young as 6 mines cobalt that could end up in your iPhone. Low traceability lets companies buy, refine and sell cobalt from both child-labor mines and industrial mining operators.',
  },
  extractionCta: {
    id: 'rm_journey_human_extraction_cta',
    defaultMessage: 'Next',
  },

  refiningLabel: {
    id: 'rm_journey_human_refining_label',
    defaultMessage: 'Refining',
  },
  refiningTitle: {
    id: 'rm_journey_human_refining_title',
    defaultMessage: 'From raw to refined.',
  },
  refiningPlace: {
    id: 'rm_journey_human_refining_place',
    defaultMessage: 'Henan Province, China',
  },
  refiningBody: {
    id: 'rm_journey_human_refining_body',
    defaultMessage:
      'Workers inhale microscopic cobalt particles and other compounds during refining. Cobalt is classified as Carcinogenic Category 1B; inhalation can damage the lungs and heart, cause respiratory sensitization, and potentially lead to cancer.',
  },
  refiningCta: {
    id: 'rm_journey_human_refining_cta',
    defaultMessage: 'Next',
  },

  manufactureLabel: {
    id: 'rm_journey_human_manufacture_label',
    defaultMessage: 'Manufacture',
  },
  manufactureTitle: {
    id: 'rm_journey_human_manufacture_title',
    defaultMessage: 'Cobalt becomes a battery.',
  },
  manufacturePlace: {
    id: 'rm_journey_human_manufacture_place',
    defaultMessage: 'Shenzhen, China',
  },
  manufactureBody: {
    id: 'rm_journey_human_manufacture_body',
    defaultMessage:
      'The cobalt is refined for use in lithium-ion batteries, including iPhone batteries. Despite Apple’s pledge to use 100% recycled cobalt by 2025, it does not disclose whether it came from mines using child labour, because there is no way to know.',
  },
  manufactureCta: {
    id: 'rm_journey_human_manufacture_cta',
    defaultMessage: 'Next',
  },

  assemblyLabel: {
    id: 'rm_journey_human_assembly_label',
    defaultMessage: 'Assembly',
  },
  assemblyTitle: {
    id: 'rm_journey_human_assembly_title',
    defaultMessage: 'Ready to assemble.',
  },
  assemblyPlace: {
    id: 'rm_journey_human_assembly_place',
    defaultMessage: 'Foxconn Factory Complex, Zhengzhou, China',
  },
  assemblyBody: {
    id: 'rm_journey_human_assembly_body',
    defaultMessage:
      'The batteries are used to manufacture iPhones by workers who put in 6-day weeks, working 12 to 14-hour shifts for low wages of $350-$500 a month. Foxconn has had an “ongoing problem with employee suicides.”',
  },
  assemblyCta: {
    id: 'rm_journey_human_assembly_cta',
    defaultMessage: 'Next',
  },

  saleLabel: {
    id: 'rm_journey_human_sale_label',
    defaultMessage: 'Sale',
  },
  saleTitle: {
    id: 'rm_journey_human_sale_title',
    defaultMessage: 'Welcome to iPhone',
  },
  salePlace: {
    id: 'rm_journey_human_sale_place',
    defaultMessage: 'Apple Flagship Store, Paris, France',
  },
  saleBody: {
    id: 'rm_journey_human_sale_body',
    defaultMessage:
      'You buy the iPhone with a battery that may have begun its life in the small hand of a child.',
  },
  saleCta: {
    id: 'rm_journey_human_sale_cta',
    defaultMessage: 'Go deeper on Cobalt',
  },
} as const
